import { lazy, ComponentType } from 'react';

// Helper to handle module loading errors by reloading the page
// This fixes "Importing a module script failed" errors caused by stale chunks
const lazyWithRetry = <T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
) =>
  lazy(() =>
    importFn().catch((error) => {
      console.error('Failed to load module, reloading page:', error);
      window.location.reload();
      throw error;
    }),
  );

// Lazy loaded components (non-critical path)
export const SignUp = lazyWithRetry(() => import('../features/auth/SignUp'));
export const SignIn = lazyWithRetry(() => import('../features/auth/SignIn'));
export const ForgotPassword = lazyWithRetry(
  () => import('../features/auth/ForgotPassword'),
);
export const ResetPassword = lazyWithRetry(
  () => import('../features/auth/ResetPassword'),
);
export const OAuthAuthorize = lazyWithRetry(
  () => import('../features/auth/OAuthAuthorize'),
);
export const RecorderDemo = lazyWithRetry(() => import('../recorder/Demo'));
export const MicroTool = lazyWithRetry(() => import('../features/microtools'));
export const SharedVideo = lazyWithRetry(
  () => import('../features/sharedVideo'),
);
export const ContactSalesPage = lazyWithRetry(
  () => import('../features/sales/ContactSalesPage'),
);
export const ContactSupportPage = lazyWithRetry(
  () => import('../features/support/ContactSupportPage'),
);
export const Redirect = lazyWithRetry(
  () => import('../features/app/RedirectToLegacy'),
);
export const Settings = lazyWithRetry(() => import('../features/settings'));
// If SelectedVideo lazy loading is bothering users, revert just that.
export const Live = lazyWithRetry(() => import('../features/live'));
export const SelectedVideo = lazyWithRetry(
  () => import('../features/selectedVideo'),
);
export const SearchPage = lazyWithRetry(() => import('../features/search'));
export const Error = lazyWithRetry(() => import('../features/app/error'));
export const SharedTemplate = lazyWithRetry(
  () => import('../features/sharedTemplate'),
);
export const EventsPage = lazyWithRetry(() => import('../features/events'));
export const HistoryPage = lazyWithRetry(() => import('../features/history'));
export const Shared = lazyWithRetry(() => import('../features/shared'));
export const SharedFileFromFolder = lazyWithRetry(
  () => import('../features/sharedFile/SharedFileFromFolder'),
);
export const SharedFileFromUser = lazyWithRetry(
  () => import('../features/sharedFile/SharedFileFromUser'),
);
export const AcceptInvitation = lazyWithRetry(
  () => import('../features/invitations/AcceptInvitationPage'),
);
export const CloneShare = lazyWithRetry(
  () => import('../features/clone-share/CloneSharePage'),
);
export const SharedFolder = lazyWithRetry(
  () => import('../features/sharedFolder'),
);
